import React from 'react'

function Footer() {
  return (
    <div className='footer-container'>
      <h1>Mrc87</h1>
    </div>
  )
}

export default Footer